import React, { useState, useEffect } from 'react';
import logo from '../../space.webp';
import Cookies from 'universal-cookie';
import './personInfo.css';
import loading from '../../img/loading.gif';
import print from '../../img/print.png'
import edit from '../../img/edit.png'
import trash from '../../img/trash.png'
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { Buffer } from 'buffer'
import { createPerson, createTraitor, createPersonCollapsed, createTraitorCollapsed, 
    createAddressCollapsed, createAutoCollapsed, createCompanyCollapsed, createContactCollapsed, 
    createGunCollapsed, createDocCollapsed, createArchCollapsed, createOPMCollapsed, createBSCollapsed, createKanCollapsed, 
    createProceedings,
    showError} from '../ViewCreator';


const cookies = new Cookies();
function ProceedingsInfo() {

    const [type, setType] = useState(0);

    const mainSubmit = () => {
        window.location.href = "/main";
    };


    useEffect(() => {
        if (cookies.get('type') != null) {
            var t = cookies.get('type')
            setType(t);
        }


        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get("id");
        sendPerson(id);
    }, []);

    const setViews = (inner) => {
        var a = document.getElementById("viewFull");
        a.innerHTML = ""
        for (let index = 0; index < inner.length; index++) {
            a.appendChild(inner[index])
        }
    }

    const sendPerson = (id) => {
        var path = ip + '/api/proceedings/info';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);


                    var zz = []

                    var pers = result.data
                    var pe = createProceedings(pers)
                    zz.push(pe)

                    
                    
                                    if(pers.opms.length>0){
                                      var opm = document.createElement('div');
                                      opm.innerHTML = "<br><hr>Заходи:";
                                      zz.push(opm)
                                      for (let index = 0; index < pers.opms.length; index++) {
                                        var a = createOPMCollapsed(pers.opms[index],index,0,"");
                                          zz.push(a)
                                          var i = pers.opms[index].id
                                          const dblcl = i => () =>{
                                            sendOPMFullScreen(i)
                                        }
                                        a.ondblclick = dblcl(pers.opms[index].id)
                                          zz.push(a)
                                      }
                                    }
                    
                                    

                    setViews(zz)

                    

                }
            })
    }

   
      const  sendOPMFullScreen = (id) => {
        window.open("/opm?id="+id)
      }
      

    

    const printSubmit = () => {

    }

   const editSubmit = () => {
           const queryParams = new URLSearchParams(window.location.search)
           const id = queryParams.get("id");
           window.open("/edit/proceedings?id="+id, "_self")
       }
   
       const trashSubmit = () => {
           Swal.fire({
               title: 'Ви дійсно бажаєте видалити запис',
               //text: "Оновити інформацію?",
               icon: 'question',
               html:
                   '',
               showDenyButton: false,
               showCancelButton: true,
               confirmButtonText: 'Видалити',
               denyButtonText: 'Оновити',
   
               background: '#2B2B2B',
               color: '#FFF'
           }).then((result) => {
               if (result.isConfirmed) {
                   removePerson()
               }
           })
       }
   
       const removePerson = () => {
           const queryParams = new URLSearchParams(window.location.search)
           const id = queryParams.get("id");
           var path = ip + '/api/proceedings/remove';
           var bd = encryptAes((id))
           const requestOptions = {
             headers: {
               'Content-Type': 'Content-type: text/html'
             },
             credentials: 'include',
             uri: path,
             encoding: 'latin1',
             body: bd,
             method: 'POST'
           };
           fetch(path, requestOptions)
             .then()
             .then(response => { return response.arrayBuffer() })
             .then((buffer) => {
               const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
               const text = decoder.decode(buffer);
               try {
                 var result = JSON.parse(text);
                 showError(result.msg)
       
               } catch (error) {
                 const decryptedText = decryptAes(text);
                 var result = JSON.parse(decryptedText);
                 storeKey('test_data', result.key);
                 Swal.fire({title: 'Видалено', text: '', icon: 'success', timer: 5000 ,background: '#2B2B2B',
                   color: '#FFF',
                   didClose: (toast) => {
                     window.open("/main","_self")
                   }})
                 
               }
             })
         }

    return (
        <div className="main">
            <div className="header">
                <img src={logo} className="logo" alt="logo" />
                <div className="title" onClick={mainSubmit}>SPACE</div>
                <div className="subtitle">(info) </div>

                <button className="headerButton" onClick={printSubmit} >
                    <img src={print} className="headerImage" />
                </button>
                <button className="headerButton" hidden={type > 2} onClick={editSubmit} >
                    <img src={edit} className="headerImage" />
                </button>
                <button className="headerButton" hidden={type > 1} onClick={trashSubmit} >
                    <img src={trash} className="headerImage" />
                </button>

            </div>


            <div id="viewFull">

            </div>
        </div>
    );
}


export default ProceedingsInfo;